import { render, staticRenderFns } from "./GAuthButton.vue?vue&type=template&id=72a9b65a&scoped=true&"
import script from "./GAuthButton.vue?vue&type=script&lang=ts&"
export * from "./GAuthButton.vue?vue&type=script&lang=ts&"
import style0 from "./GAuthButton.vue?vue&type=style&index=0&id=72a9b65a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a9b65a",
  null
  
)

export default component.exports